import objectToFormData from '~/utilities/object-to-formdata'

export default ({ store, $axios, app }) => ({
  getTestimonials: params => $axios
    .$get('/testimonials.json', {
      params
    })
    .then(res => res.results),

  getLandingPageImages: params => $axios
    .$get('/landing_page_images.json', {
      params
    }),

  getPrivacyPolicy: () => $axios.$get('/privacy_policy.json')
    .then(res => res.privacy_policy),

  getTermOfUse: () => $axios.$get('/terms_of_use.json')
    .then(res => res.terms_of_use),

  acceptAgreements (data) {
    const role = store.getters['authentication/apiRole']
    const endpoint = {
      buyer: '/buyer/term_agreement.json',
      headBuyer: '/head_buyer/term_agreement.json',
      vendor: '/vendor/term_agreement.json',
      broker: '/broker/term_agreement.json',
      lp: '/logistics_partner/term_agreement.json'
    }[role]

    if (!endpoint) return Promise.resolve()

    return $axios.$post(endpoint, data)
  },

  getAnnouncements () {
    const role = store.getters['authentication/apiRole']
    const endpoint = {
      buyer: '/buyer/announcements.json',
      headBuyer: '/head_buyer/announcements.json',
      vendor: '/vendor/announcements.json',
      broker: '/vendor/announcements.json',
      lp: '/logistics_partner/announcements.json'
    }[role]

    if (!endpoint) return Promise.resolve([])

    return $axios
      .$get(endpoint)
      .then(res => res.results)
  },

  markAnnouncementAsRead ({ id }) {
    const role = store.getters['authentication/apiRole']
    const endpoint = {
      buyer: `/buyer/announcements/${id}/mark_as_read.json`,
      headBuyer: `/head_buyer/announcements/${id}/mark_as_read.json`,
      vendor: `/vendor/announcements/${id}/mark_as_read.json`,
      broker: `/vendor/announcements/${id}/mark_as_read.json`,
      lp: `/logistics_partner/announcements/${id}/mark_as_read.json`
    }[role]
    if (!endpoint) return Promise.resolve([])
    return $axios
      .$post(endpoint)
      .then(res => res.results)
  },

  master () {
    const role = store.getters['authentication/apiRole']
    const endpoint = {
      vendor: '/vendor/supports/master_datas.json',
      broker: '/broker/supports/master_datas.json',
      buyer: '/buyer/supports/master_datas.json',
      lp: '/logistics_partner/supports/master_datas.json'
    }[role] || '/supports/master_datas.json'
    return $axios.$get(endpoint)
  },

  getBrandDetails (id) {
    const role = store.getters['authentication/apiRole']
    const endpoint = {
      buyer: `/buyer/brands/${id}.json`,
      vendor: `/vendor/brands/${id}.json`,
      broker: `/vendor/brands/${id}.json`
    }[role] || `/brands/${id}.json`
    return $axios.$get(endpoint).then(({ brand }) => brand)
  },

  claims: (data) =>
    $axios.$post('/claims.json', objectToFormData({ claim: data })),

  submitRequestAccessForm: (form, token) =>
    $axios.$post('/registration_forms.json', {
      registration_form: form,
      recaptcha_token: token
    }),

  submitLogisticsPartnerForm: form =>
    $axios.$post('/monday_forms/logistics_partners.json', {
      logistics_partner: form
    }),

  submitStateOfGroceryForm: form =>
    $axios.$post('/monday_forms/state_of_groceries.json', {
      state_of_grocery: form
    }),

  submit3PLLeadForm: (form, token) =>
    $axios.$post('/pod3pl_inquiries.json', { ...form, recaptcha_token: token }),

  getPodcasts: params =>
    $axios.$get('/podcasts.json', { params }),

  getPodcast: id =>
    $axios.$get(`/podcasts/${id}.json`),

  onboardingChecklist: (data, token) =>
    $axios.$post('/vendor_company_checklist.json', objectToFormData({
      vendor_company_checklist: data,
      recaptcha_token: token
    })),

  onboardingAgreement: (data, token) =>
    $axios.$post('/vendor_company_agreement.json', objectToFormData({
      vendor_company_agreement: data,
      recaptcha_token: token
    })),

  onboardingCompanyDetail: (data, token) =>
    $axios.$post('/vendor_company_detail.json', objectToFormData({
      vendor_company_detail: data,
      recaptcha_token: token
    })),

  trackInvoicePod: (params, token) =>
    $axios.$get('/sub_invoices.json', { params }),

  submitPodCreativeForm: (data, token) =>
    $axios.$post('/creative_submissions.json', {
      creative_submission: data,
      recaptcha_token: token
    })
})
